export enum EmailLookupStatus {
  FOUND = "existingVerificationFound",
  NOT_FOUND = "existingVerificationNotFound",
  PENDING = "pendingVerification",
  REJECTED = "rejectedVerification",
  ALREADY_INITIATED = "emailResendAlreadyInitiated",
}

export type EmailLookupResponse = {
  status: EmailLookupStatus;
  message: string | null;
};

export type EmailFirstCollectInfoStep =
  | "message-dimmed-fields"
  | "no-message-dimmed-fields"
  | "control"
  | "default";

export interface VerificationHelpRequestApiResponse {
  systemErrorMessage?: string;
  currentStep?: string;
  status?: number;
}
